import React, { useContext, useState } from 'react';
import { AntdPageHeader, ContentWrapper, Form, ButtonGroup, CardTitle } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { Card, Divider, message } from 'antd';
import { formatPayload, getSuccessfulMessage } from './common/helpers';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { useMutation } from '@tanstack/react-query';
import { apiPost } from 'helpers/ApiHelper';
import { onError } from 'components/landlord_app/application_management/common/ErrorHandling';
import IncentiveForm from './IncentiveForm';
import { IncentiveStatusTag, incentiveStatus } from './common/IncentiveStatus';

const CreateIncentive = ({ router }) => {
  const [createIncentiveForm] = Form.useForm();
  const { isMobile } = useContext(ApplicationUIContext);
  const [isError, setIsError] = useState(false);
  const status = Form.useWatch('status', createIncentiveForm);

  const createIncentiveMutation = useMutation({
    mutationFn: (data) => apiPost('/landlords/incentives/incentive_templates', formatPayload(data)),
    onSuccess: (response) => {
      const template = response.incentive_template;
      message.success(getSuccessfulMessage(status));

      if (template?.id) {
        router.push(`/companies/incentives/${template.id}`);
      }
    },
    onError,
  });

  const onSaveDraft = () => {
    createIncentiveForm.setFieldsValue({ status: incentiveStatus.draft });
    createIncentiveForm.submit();
  };

  const onPublish = () => {
    createIncentiveForm.setFieldsValue({ status: incentiveStatus.published });
    createIncentiveForm.submit();
  };

  const handleFinish = (data) => {
    createIncentiveMutation.mutate(data);
    setIsError(false);
  };

  const handleFinishFailed = () => {
    setIsError(true);
  };

  return (
    <div className="body" role="main">
      <AntdPageHeader
        onBack={() => router.push('/companies/incentives')}
        title={getTranslatedString('landlordPortal.incentives.createIncentiveTemplate')}
        extra={
          <ButtonGroup
            buttons={[
              {
                label: getTranslatedString('landlordPortal.incentives.saveAsDraft'),
                onClick: onSaveDraft,
                type: 'secondary',
                loading: createIncentiveMutation.isLoading,
              },
              {
                label: getTranslatedString('landlordPortal.incentives.publish'),
                onClick: onPublish,
                type: 'primary',
                loading: createIncentiveMutation.isLoading,
              },
            ]}
            isMobile={isMobile}
          />
        }
        tags={[IncentiveStatusTag({ status: incentiveStatus.draft })]}
        isMobile={isMobile}
      />
      <ContentWrapper>
        <Card
          style={{ maxWidth: 584 }}
          bodyStyle={{ padding: isMobile && 16, fontSize: isMobile && 16 }}
        >
          <CardTitle>{getTranslatedString('landlordPortal.incentives.configuration')}</CardTitle>

          <Divider />

          <IncentiveForm
            form={createIncentiveForm}
            onFinish={handleFinish}
            onFinishFailed={handleFinishFailed}
            isError={isError}
          />
        </Card>
      </ContentWrapper>
    </div>
  );
};

export default CreateIncentive;
